import React from "react";
import { componentStyles } from "./switch.scss";
import classnames from "classnames";

const Switch = ({
  handleToggle,
  switchButtonColor,
  switchBackgroundColor,
  leftPhrase,
  rightPhrase,
  isOn,
  IsOnRightTextColor,
  IsOffRightTextColor,
  IsOnLeftTextColor,
  IsOffLeftTextColor
}) => {
  return (
      <label className="switch" style={{ "--background-color": switchBackgroundColor }}>
        <input onChange={handleToggle} className="switch-checkbox" type="checkbox" />
        <div className="switch-button" style={{ "--switch-color": switchButtonColor }} />
        <div className="switch-labels">
          <span
            className={classnames("switch-text", { "is-on": isOn })}
            style={{ "--is-on-color": IsOnLeftTextColor, "--is-off-color": IsOffLeftTextColor }}
          >
            {leftPhrase}
          </span>
          <span
            className={classnames("switch-text", { "is-on": isOn })}
            style={{ "--is-on-color": IsOnRightTextColor, "--is-off-color": IsOffRightTextColor }}
          >
            {rightPhrase}
          </span>
        </div>
        <style jsx>{componentStyles}</style>
      </label>
  );
};

export default Switch;
